import { render, staticRenderFns } from "./SequenceDiagramSimpleRenderer.vue?vue&type=template&id=30b5acc2&"
import script from "./SequenceDiagramSimpleRenderer.vue?vue&type=script&lang=ts&"
export * from "./SequenceDiagramSimpleRenderer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports